import React from "react"
import { TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody, FontIcon } from "material-ui"
import strings from "../../localization/strings"
import Table from "../../components/common/Table"
import { IJobPhase } from "../../models"
import { green500 } from "material-ui/styles/colors"
interface IProps {
    readonly: boolean
    phases: IJobPhase[]
    selectedPhases: IJobPhase[]
    handleClickRow(phase: IJobPhase): void
    handleSelect(phases: IJobPhase[]): void
}

const PhaseTable: React.SFC<IProps> = (props: IProps) => {
    return (
        <Table
            readonly={props.readonly}
            allowClickRow
            items={props.phases}
            handleSelect={props.handleSelect}
            handleClickRow={phase => props.handleClickRow(phase)}
        >
            <TableHeader>
                <TableRow>
                    <TableHeaderColumn style={{ textAlign: "left", width: 150, paddingLeft: 5, paddingRight: 5 }}>{strings.Name}</TableHeaderColumn>
                    <TableHeaderColumn style={{ textAlign: "left", width: 100, paddingLeft: 5, paddingRight: 5 }}>{strings.Cost_Code}</TableHeaderColumn>
                    <TableHeaderColumn style={{ textAlign: "center", width: 80, paddingLeft: 5, paddingRight: 5 }}>{strings.Active}</TableHeaderColumn>
                </TableRow>
            </TableHeader>
            <TableBody deselectOnClickaway={false}>
                {props.phases
                .sort((prev: IJobPhase, next: IJobPhase) => prev.Name.localeCompare(next.Name))
                .map((phase, index) =>
                    <TableRow data-intercom-target={index === 0 && "menu-Jobs-JobDetails-PhasesTab-openPhaseDetails"} key={index} selected={props.selectedPhases.find(i => i.Id === phase.Id) ? true : false}>
                        <TableRowColumn style={{ textAlign: "left", cursor: "pointer", width: 150, paddingLeft: 5, paddingRight: 5 }} title={phase.Name}>
                            {phase.Name}
                        </TableRowColumn>
                        <TableRowColumn style={{ textAlign: "left", cursor: "pointer", width: 100, paddingLeft: 5, paddingRight: 5 }}>
                            {phase.CostCode}
                        </TableRowColumn>
                        <TableRowColumn style={{ textAlign: "center", cursor: "pointer", width: 80, paddingLeft: 5, paddingRight: 5 }}>
                            {phase.Active &&
                                <FontIcon className="fa fa-check" style={{ fontSize: 18, color: green500 }} />
                            }
                        </TableRowColumn>
                    </TableRow>
                )}
            </TableBody>
        </Table>
    )
}

export default PhaseTable